import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnChanges,
  Input,
} from '@angular/core';
import { Router } from '@angular/router';
import { NavService } from '../../../../../services/nav.service';
import { MaterialModule } from 'src/app/material.module';
import { TablerIconsModule } from 'angular-tabler-icons';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-horizontal-nav-item',
    imports: [MaterialModule, TablerIconsModule, CommonModule],
    templateUrl: './nav-item.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppHorizontalNavItemComponent implements OnChanges {
  @Input() depth: any;
  @Input() item: any;
  expanded: boolean = false;

  constructor(
    public navService: NavService,
    public router: Router,
    private readonly cdr: ChangeDetectorRef
  ) {
    if (this.depth === undefined) {
      this.depth = 0;
    }
  }

  // `router.isActive(...)` é lido direto no template para a classe `activeMenu` — sem essa
  // assinatura, sob OnPush o destaque do item ativo não atualizaria ao navegar por outra rota
  // (mesmo padrão já usado em app-nav-item, o item de menu vertical).
  ngOnChanges() {
    this.navService.currentUrl.subscribe(() => {
      this.cdr.markForCheck();
    });
  }

  // Páginas com abas (TabService) acrescentam `?tab=N` na URL para lembrar a aba selecionada.
  // `router.isActive(route, true)` exige correspondência exata de query params, então nunca
  // considerava essas páginas "ativas" (a URL do menu nunca tem o `?tab=`, a URL real sempre
  // tem). Ignorar query params aqui resolve sem afetar o resto do comportamento de destaque.
  isRouteActive(route: string): boolean {
    return this.router.isActive(route, {
      paths: 'exact',
      queryParams: 'ignored',
      fragment: 'ignored',
      matrixParams: 'ignored',
    });
  }

  onItemSelected(item: any) {
    if (!item.children || !item.children.length) {
      this.router.navigate([item.route]);
    } else {
      this.expanded = !this.expanded;
    }
  }
}
